/* eslint-disable @typescript-eslint/no-explicit-any */

export function callPostyAppFunction(function_name: 'back' | 'close'): void;
export function callPostyAppFunction(function_name: string, parameters?: Record<string, any>): void {
  const _window: any = window;
  if (_window.webkit?.messageHandlers?.posty) {
    // iOS
    _window.webkit.messageHandlers.posty.postMessage({
      name: function_name,
      parameters,
    });
  } else if (_window.posty?.[function_name]) {
    // Android
    if (parameters) {
      _window.posty[function_name](parameters);
    } else {
      _window.posty[function_name]();
    }
  }
}
